import { createRouter, createWebHistory } from 'vue-router'

import { checkConversionCardsFeatureFlag } from '@/features/conversion-cards/router/guards/checkConversionCardsFeatureFlag'
import { sendPageLoad } from '@/plugins/analytics'

import { checkAuthenticated } from './guards/checkAuthenticated'
import { checkGetAppPrompt } from './guards/checkGetAppPrompt'
import { checkPermissions } from './guards/checkPermissions'
import { checkSessionExpiration } from './guards/checkSessionExpiration'
import routes from './routes'

export const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: 'is-active',
  routes,
})

const guards = [
  checkGetAppPrompt,
  checkAuthenticated,
  checkSessionExpiration,
  checkPermissions,
  checkConversionCardsFeatureFlag,
]

router.beforeEach(async (to) => {
  for (const guard of guards) {
    const redirect = await guard(to)
    if (redirect) return redirect
  }
})

router.afterEach((to) => {
  if (to?.name && typeof to.name === 'string') sendPageLoad(to.name)
})
